/* The sound of every order a player gives over a socket (owner, 2026-10-25: "when upgrading
   building we don't have [a sound]. Make sure everything (or almost everything) does").

   One table at the one door every order leaves by — `wsClient.send` — rather than a call beside
   each of the sixty senders: a button, its keyboard shortcut and the city sheet's copy of it all
   sound alike, and a new order is one row here. The sound plays once the order has left (or been
   handed to basic training's local server), never for one a dropped socket kept.

   What is deliberately NOT here, because the player did not press anything: `next_round` (the
   host's clock sends it; the round turning has its own sound, off the server's answer),
   `check_arrivals`, `set_fog_preview` and `claim_host`. And `send_reaction`, whose sound plays
   when the reaction comes back, for everybody at once. */

import { playUiSound } from "src/utils/audio"

const TAKEN_BACK = "cancel"

const GAME = {
  move_troops: "march",
  attack: "march",
  missile_strike: "march",
  tunnel_load: "tunnel",
  tunnel_unload: "tunnel",
  level_up_building: "build",
  apply_research: "build",
  found_settlement: "build",
  discharge_units: "build",
  // An empty queue is the CLEAR button: the order taken back, not one given.
  enqueue_troops: (message) => (Object.keys(message.troops || {}).length ? "build" : TAKEN_BACK),
  cancel_upgrade: TAKEN_BACK,
  cancel_founding: TAKEN_BACK,
  cancel_movement: TAKEN_BACK,
  cancel_strike: TAKEN_BACK,
  cancel_tunnel_order: TAKEN_BACK,
  cancel_discharge: TAKEN_BACK,
  set_ready: "endTurn",
  unset_ready: TAKEN_BACK,
  trade: "click",
  set_formation: "click",
  send_chat_message: "click",
  pause_game: "click",
  resume_game: "click",
  surrender: "click",
  stop_spectating: "close",
}

const LOBBY = {
  join_team: "click",
  leave_team: TAKEN_BACK,
  change_race: "click",
  change_unit_icon: "click",
  switch_location: "click",
  add_bot: "click",
  remove_bot: TAKEN_BACK,
  set_bot_race: "click",
  remove_member: TAKEN_BACK,
  set_map_size: "click",
  set_ranked: "click",
  set_round_seconds: "click",
  set_survival_difficulty: "click",
  set_ready: "endTurn",
  unset_ready: TAKEN_BACK,
  start_game: "click",
  send_chat_message: "click",
}

const TABLES = { game: GAME, lobby: LOBBY }

// Two sends from one press (the lobby's pick that first gives back the oldest city) are one sound.
const SAME_PRESS_MS = 60

/** The sound for `message` sent on the socket `key`, or null for an order that makes none. */
export const orderSoundFor = (key, message) => {
  const entry = TABLES[key]?.[message?.action]
  if (!entry) return null
  return typeof entry === "function" ? entry(message) : entry
}

export const soundTheOrder = (key, message) => {
  const sound = orderSoundFor(key, message)
  if (sound) playUiSound(sound, { unlessWithinMs: SAME_PRESS_MS })
}
